import resultsTableStyle from 'src/components/View/Page/ResultsTable/resultsTable.style';

const resultsStyle = (theme) => ({
  ...resultsTableStyle,
  root: {
    ...resultsTableStyle.root,
  },
  queryField: {
    width: 500
  },
  bulkOperations: {
    position: 'relative'
  },
  bulkActions: {
    paddingLeft: 4,
    paddingRight: 4,
    marginTop: 6,
    position: 'absolute',
    width: '100%',
    zIndex: 2,
    backgroundColor: theme.palette.background.default
  },
  bulkAction: {
    marginLeft: theme.spacing(2)
  },
  nowrap: {
    whiteSpace: 'nowrap',
  },
  contactsCount: {
    '& .MuiChip-root': {
      backgroundColor: theme.palette.grey[100],
      borderRadius: '4px',
      color: '#546E7A',
      fontSize: '14px',
      '& .MuiChip-icon': {
        color: '#B5B5B5',
      },
    },
  },
  textMessages: {
    minWidth: 280,
    whiteSpace: 'pre-wrap'
  },
  image: {
    minWidth: 150,
    '& img': {
      width: 150,
      height: 150,
      objectFit: 'contain',
      border: '1px solid #CCCCCC',
      borderRadius: 5,
      padding: 10,
      boxSizing: 'border-box',
      backgroundColor: '#FFFFFF',
    }
  },
});

export default resultsStyle;
